export default "__VITE_ASSET__c50acebe__"